import { ImgProps } from "assets/images/types";

export default function ImgHavaianas(props: ImgProps) {
	const { height = 48, width = 156 } = props;
	return (
		<img
			src="/assets/images/companies/havaianas.webp"
			alt="Havaianas logo"
			loading="lazy"
			width={width}
			height={height}
		/>
	);
}
